import 'vue/jsx'

// 引入unocss
import '@/plugins/unocss'

// 导入全局的svg图标
import '@/plugins/svgIcon'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 全局组件
import { setupGlobCom } from '@/components'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 引入全局样式
import '@/styles/index.less'

// 引入动画
import '@/plugins/animate.css'

// 引入图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 路由
import { setupRouter } from './router'

// 权限
import { setupPermission } from './directives'

import { createApp } from 'vue'

import App from './App.vue'

import 'animate.css'

import './permission'

// 创建实例
const setupAll = async () => {
  const app = createApp(App)

  await setupI18n(app)

  setupStore(app)

  setupGlobCom(app)

  setupElementPlus(app)

  setupRouter(app)

  setupPermission(app)

  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
  
  app.mount('#app')

}

setupAll()

window.addEventListener('storage', (event) => {
  if (event.key == 'user') {
    const oldValue = JSON.parse(event.oldValue ?? '');
    const newValue = JSON.parse(event.newValue ?? '');
    if(null == oldValue.userInfo && null == newValue.userInfo) return
    if(null == newValue.userInfo || null == oldValue.userInfo){
      window.location.reload()
    } 
    if(oldValue.userInfo.id != newValue.userInfo.id){
      window.location.reload()
    }
  }
});
